<template @scroll="onScroll">
  <section class="resume-content">
    <div class="pathInfo">当前位置：人才招聘 > 岗位详情 > 申请职位</div>
    <section class="resume-container container">
      <el-form
        ref="form"
        :model="form"
        label-width="130px"
        label-position="right"
      >
        <el-card class="resume-card" id="card-1">
          <div slot="header" class="clearfix">
            <span>应聘信息</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="应聘部门">
                {{ recruit.dept_NAME }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="应聘职位">
                {{ recruit.name }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否同意调岗" required>
                <el-radio
                  v-model="form.resume.CFSftg"
                  :label="1"
                  @change="changeCFSftg"
                  >同意</el-radio
                >
                <el-radio v-model="form.resume.CFSftg" :label="0"
                  >不同意</el-radio
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="resume-card" id="card-2">
          <div slot="header" class="clearfix">
            <span>个人信息</span>
          </div>
          <div class="oneMain">
            <div>
              <el-form-item label="姓名" required>
                <el-input v-model="form.resume.Fname" maxlength="50" />
              </el-form-item>
              <el-form-item label="身份证号" prop="resume.FIdentityCardNo" :rules="{ validator:isCardID, trigger: 'blur' }" required >
                <el-input
                  v-model="form.resume.FIdentityCardNo"
                  maxlength="50"
                />
              </el-form-item>
              <el-form-item label="性别" required>
                <el-radio v-model="form.resume.Fsex" :label="1">男</el-radio>
                <el-radio v-model="form.resume.Fsex" :label="2">女</el-radio>
              </el-form-item>
              <el-form-item label="国籍">
                <el-select v-model="form.resume.FNationalID">
                  <el-option
                    v-for="(item, index) in options.FNational"
                    :key="index"
                    :value="item.fid"
                    :label="item.fname"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="最高学历" required>
                <el-select v-model="form.resume.FHDegreeID">
                  <el-option
                    v-for="(item, index) in options.FHDegree"
                    :value="item.fid"
                    :label="item.fname"
                    :key="index"
                    >{{ item.fname }}</el-option
                  >
                </el-select>
              </el-form-item>
              <el-form-item label="政治面貌" required>
                <el-select
                  v-model="form.resume.FPoliticalFaceID"
                  @change="chooseParty"
                >
                  <el-option
                    v-for="(item, index) in options.FPoliticalFace"
                    :key="index"
                    :value="item.fid"
                    :label="item.fname"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="入党时间"
                :required="partytimeRequire"
                :hidden="partytimeHidden"
              >
                <el-date-picker
                  v-model="form.resume.partyTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="入党时间"
                />
              </el-form-item>
              <el-form-item label="身高">
                <el-input
                  v-model="form.resume.Fstature"
                  maxlength="50"
                  onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
                >
                  <div slot="append">cm</div>
                </el-input>
              </el-form-item>

              <el-form-item label="现居住址" required>
                <el-cascader
                  :options="cascaderOptions"
                  v-model="auto.FNowResidence"
                  @change="handleFNowResidenceChange"
                />
              </el-form-item>
              <el-form-item label="家庭住址" required>
                <el-input v-model="form.resume.birthplace" maxlength="50" />
              </el-form-item>
              <!--   <el-cascader
                 :options="cascaderOptions"
                 v-model="auto.birthplace"
                 @change="handlebirthplaceChange">
               </el-cascader>-->
              <el-form-item label="微信号">
                <el-input v-model="form.resume.FWeChat" maxlength="50" />
              </el-form-item>
              <el-form-item label="紧急联系人" required>
                <el-input
                  v-model="form.resume.FEmergencyContact"
                  maxlength="50"
                />
              </el-form-item>
            </div>
            <div>
              <el-form-item label="护照号码">
                <el-input v-model="form.resume.FPassportNo" maxlength="50" />
              </el-form-item>
              <el-form-item label="出生日期" required>
                <el-date-picker
                  v-model="form.resume.Fbirthday"
                  value-format="yyyy-M-d"
                  type="date"
                  placeholder="出生日期"
                />
              </el-form-item>
              <el-form-item label="籍贯" required>
                <el-input v-model="form.resume.FNativePlace" maxlength="50" />
              </el-form-item>
              <el-form-item label="民族" required>
                <el-select v-model="form.resume.FolkID" filterable>
                  <el-option
                    v-for="(item, index) in options.Folk"
                    :key="index"
                    :value="item.fid"
                    :label="item.fname"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="手机号码" prop="resume.FMobilePhone" :rules="{validator: validatePhone, trigger: 'blur'}" required>
                <el-input v-model="form.resume.FMobilePhone" maxlength="11" />
              </el-form-item>
              <el-form-item label="婚姻状态" required>
                <el-select v-model="form.resume.FWedID">
                  <el-option
                    v-for="(item, index) in options.FWed"
                    :key="index"
                    :value="item.fid"
                    :label="item.fname"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="驾驶证">
                <el-select v-model="form.resume.FDriversLicense">
                  <el-option
                    v-for="(item, index) in options.DriversLicenseDICT"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="电子邮箱" prop="resume.Femail" :rules="{ validator:validateMail, trigger: 'blur' }" required>
                <el-input v-model="form.resume.Femail" maxlength="50" />
              </el-form-item>
              <el-form-item label="家庭电话">
                <el-input v-model="form.resume.FixedPhone" maxlength="50" />
              </el-form-item>
              <el-form-item label="QQ号">
                <el-input v-model="form.resume.FQQ"
                          maxlength="50"
                          onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
                />
              </el-form-item>
              <el-form-item label="紧急联系人电话" prop="resume.FEmergencyContactPhone"
                            :rules="{ validator:validatePhone, trigger: 'blur' }" required>
                <el-input
                  v-model="form.resume.FEmergencyContactPhone"
                  maxlength="11"
                />
              </el-form-item>
            </div>
            <div style="text-align: center">
              <el-upload
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :action="avatarUrl"
                class="avatar-uploader"
              >
                <img
                  v-if="form.resume.AVATAR"
                  :src="form.resume.AVATAR"
                  class="avatar"
                />
                <!-- <i vclass="el-icon-plus avatar-uploader-icon"  /> -->
                <template v-else>
                  <div class="avatar-uploader-icon">jpg/png小于2M</div>
                </template>
              </el-upload>
              <div>近期2寸免冠照<span style="color: red">*</span></div>
            </div>
          </div>
          <div>
            <el-form-item label="户口所在地" required>
              <el-input v-model="form.resume.FDomicilePlace" maxlength="50" />
            </el-form-item>
            <el-form-item label="参加工作时间" :rules="{required:isSocialRecruit, message:'请输入参加工作时间', trigger:'blur'}">
              <el-date-picker
                  v-model="form.resume.FWorkDate"
                  value-format="yyyy-M-d"
                  type="date"
                  placeholder="参加工作时间"
              />
            </el-form-item>
            <el-form-item label="工作单位" :rules="{required:isSocialRecruit, message:'请输入工作单位', trigger:'blur'}">
              <el-input v-model="form.resume.workUnits" maxlength="50" />
            </el-form-item>
            <el-form-item label="其他特长">
              <el-input
                :rows="3"
                type="textarea"
                v-model="form.resume.otherspecial"
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
          </div>
        </el-card>
        <el-card id="card-3" class="resume-card">
          <div slot="header" class="clearfix">
            <span>求职意向</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="期望月薪" :rules="{required:isSocialRecruit, message:'请输入期望月薪', trigger:'blur'}">
                <el-select v-model="form.resume.CFQwyxID">
                  <el-option
                    v-for="(item, index) in options.CFQwyx"
                    :key="index"
                    :value="item.fid"
                    :label="item.fname"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="目前工作状态" :rules="{required:isSocialRecruit, message:'请输入目前工作状态', trigger:'blur'}">
                <el-select v-model="form.resume.FCurrentWorkingStatusID">
                  <el-option
                    v-for="(item, index) in options.FCurrentWorkingStatus"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-4" class="resume-card">
          <div slot="header" class="clearfix">
            <span>自我描述</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="描述" required>
                <el-input
                  v-model="form.resume.FSelfEvaluation"
                  :rows="9"
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-5" class="resume-card">
          <div slot="header" class="clearfix">
            <span>工作经历</span>
            <p class="header-tip">
              <br />1、请按正序填写，实习经验勿写，最初工作开始时间为初次签订劳动合同时间；<br />2、同一单位不同时间任不同岗位请分阶段新增填写；<br />3、从毕业至今的工作经历填写完整，空白期超过3个月的请在自我描述中说明
            </p>
            <el-button type="danger" @click="addDynamicItem('WorkExp')"
              >新增</el-button
            >
          </div>
          <el-row
            v-for="(item, index) in form.WorkExp"
            :gutter="20"
            :key="index"
            class="dynamic-item"
          >
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="开始时间" required>
                    <el-date-picker
                      v-model="item.DateStart"
                      :picker-options="endDatePickerOptions"
                      value-format="yyyy-M-d"
                      type="date"
                      placeholder="开始时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="结束时间" required>
                    <el-date-picker
                      v-model="item.DateEnd"
                      :picker-options="endDatePickerOptions"
                      value-format="yyyy-M-d"
                      type="date"
                      placeholder="结束时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="相关工作年限" required>
                    <el-input
                      v-model="item.XGGZNX"
                      :disabled="true"
                      :min="1"
                      label="相关工作年限"
                      maxlength="50"
                    >
                      <div slot="append">月</div>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="公司名称" required>
                    <el-input v-model="item.Company" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="公司人数" required>
                    <el-select v-model="item.TotalStaff">
                      <el-option value="100以下" label="100以下" />
                      <el-option value="100-500" label="100-500" />
                      <el-option value="500以上" label="500以上" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="任职部门" required>
                    <el-input v-model="item.Department" maxlength="50" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="行业类别" required>
                    <el-select v-model="item.HYLBID">
                      <el-option
                        v-for="(item, index) in options.HYLB"
                        :key="index"
                        :value="item.fid"
                        :label="item.fname"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="相关职位类别" required>
                    <el-select v-model="item.XGZWLBID" filterable>
                      <el-option
                        v-for="(item, index) in options.XGZWLB"
                        :key="index"
                        :value="item.fid"
                        :label="item.fname"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="职位名称" required>
                    <el-input v-model="item.Position" maxlength="50" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="月薪" required>
                    <el-input v-model="item.MonthPay" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证明人" required>
                    <el-input v-model="item.Certifier" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证明人电话" required>
                    <el-input v-model="item.CertifierPhone" maxlength="11" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="离职原因">
                    <el-input
                      v-model="item.LeavingReason"
                      :rows="6"
                      type="textarea"
                      maxlength="300"
                      show-word-limit
                      placeholder="离职原因"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="工作描述" required>
                    <el-input
                      v-model="item.JobDescription"
                      :rows="9"
                      type="textarea"
                      maxlength="500"
                      show-word-limit
                      placeholder="工作描述"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-button @click="removeDynamicItem(index, 'WorkExp')"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-6" class="resume-card">
          <div slot="header" class="clearfix">
            <span>教育经历<span style="color: red">*</span></span>
            <p class="header-tip">
              从大中专院校开始填起，请务必填写全日制学历。<br />如大专是函授，请先填写全日制中专，再填写函授大专；如本科是专升本，请先填写大专学历，再填写本科学历。
            </p>
            <el-button type="danger" @click="addDynamicItem('EduExp')">新增</el-button>
          </div>
          <el-row
            v-for="(item, index) in form.EduExp"
            :gutter="20"
            :key="index"
            class="dynamic-item"
          >
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="毕业院校" required>
                    <el-input v-model="item.School" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="专业" required>
                    <el-input v-model="item.Major" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="教育类型" required>
                    <el-select v-model="item.JYLXID">
                      <el-option
                        v-for="(item, index) in options.JYLX"
                        :key="index"
                        :value="item.id"
                        :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="入学时间" required>
                    <el-date-picker
                      v-model="item.DateStart"
                      :picker-options="endDatePickerOptions"
                      value-format="yyyy-M-d"
                      type="date"
                      placeholder="入学时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="毕业时间" required>
                    <el-date-picker
                      v-model="item.DateEnd"
                      value-format="yyyy-M-d"
                      type="date"
                      placeholder="毕业时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="毕业类型" required>
                    <el-select v-model="item.GraduateTypeID" @change="onChangeGraduateType">
                      <el-option
                        v-for="(item, index) in options.GraduateType"
                        :key="index"
                        :value="item.fid"
                        :label="item.fname"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="学历" required>
                    <el-select v-model="item.DegreeID">
                      <el-option
                        v-for="(item, index) in options.FHDegree"
                        :key="index"
                        :value="item.fid"
                        :label="item.fname"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学历证书编号" :rules="{required:isCertNoRequire, message:'请输入学历证书编号', trigger:'blur'}">
                    <el-input v-model="item.XLZS_NO" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学位" required>
                    <el-select v-model="item.AcademicDiplomasID">
                      <el-option
                        v-for="(item, index) in options.AcademicDiplomas"
                        :key="index"
                        :value="item.fid"
                        :label="item.fname"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="专业描述" required>
                    <el-input
                      v-model="item.MajorDescription"
                      :rows="6"
                      type="textarea"
                      maxlength="300"
                      show-word-limit
                      placeholder="专业描述"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-button @click="removeDynamicItem(index, 'EduExp')"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-7" class="resume-card">
          <div slot="header" class="clearfix">
            <span>项目经历</span>
            <el-button type="danger" @click="addDynamicItem('ProExp')"
              >新增</el-button
            >
          </div>
          <el-row
            v-for="(item, index) in form.ProExp"
            :gutter="20"
            :key="index"
            class="dynamic-item"
          >
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="开始时间" required>
                    <el-date-picker
                      v-model="item.DateStart"
                      :picker-options="endDatePickerOptions"
                      value-format="yyyy-M-d"
                      type="date"
                      placeholder="开始时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="结束时间" required>
                    <el-date-picker
                      v-model="item.DateEnd"
                      :picker-options="endDatePickerOptions"
                      value-format="yyyy-M-d"
                      type="date"
                      placeholder="结束时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="项目名称" required>
                    <el-input v-model="item.Customer" maxlength="100" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="所属行业" required>
                    <el-input v-model="item.Findustry" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="担任角色" required>
                    <el-input v-model="item.Frole" maxlength="50" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="主要职责" required>
                    <el-input
                      v-model="item.Fduty"
                      :rows="6"
                      type="textarea"
                      maxlength="300"
                      show-word-limit
                      placeholder="主要职责"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="项目描述" required>
                    <el-input
                      v-model="item.ProjectDescription"
                      :rows="6"
                      type="textarea"
                      maxlength="300"
                      show-word-limit
                      placeholder="项目描述"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-button @click="removeDynamicItem(index, 'ProExp')"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-8" class="resume-card">
          <div slot="header" class="clearfix">
            <span>职称</span>
            <el-button type="danger" @click="addDynamicItem('TechPost')"
              >新增</el-button
            >
          </div>
          <el-row
            v-for="(item, index) in form.TechPost"
            :gutter="20"
            :key="index"
            class="dynamic-item"
          >
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="职称名称" required>
                    <el-input v-model="item.CredentialName" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="职称级别" required>
                    <el-select v-model="item.LevelID">
                      <el-option
                        v-for="(item, index) in options.TechPostLevel"
                        :key="index"
                        :value="item.id"
                        :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证书编号" required>
                    <el-input v-model="item.Grade" maxlength="50" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="证书取得时间">
                    <el-date-picker
                      v-model="item.Date"
                      :picker-options="endDatePickerOptions"
                      value-format="yyyy-M-d"
                      type="date"
                      placeholder="证书取得时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发证机构" required>
                    <el-input v-model="item.TCB" maxlength="50" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-button @click="removeDynamicItem(index, 'TechPost')"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-9" class="resume-card">
          <div slot="header" class="clearfix">
            <span>职（执）业资格及其他技能证书</span>
            <el-button type="danger" @click="addDynamicItem('TechPost2')"
              >新增</el-button
            >
          </div>
          <el-row
            v-for="(item, index) in form.TechPost2"
            :gutter="20"
            :key="index"
            class="dynamic-item"
          >
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="证书名称" required>
                    <el-input v-model="item.CredentialName" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证书级别" required>
                    <el-select v-model="item.LevelID">
                      <el-option
                        v-for="(item, index) in options.TechPostLevel"
                        :key="index"
                        :value="item.id"
                        :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证书编号" required>
                    <el-input v-model="item.Grade" maxlength="50" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="证书取得时间">
                    <el-date-picker
                      v-model="item.Date"
                      :picker-options="endDatePickerOptions"
                      value-format="yyyy-M-d"
                      type="date"
                      placeholder="证书取得时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发证机构" required>
                    <el-input v-model="item.TCB" maxlength="50" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-button @click="removeDynamicItem(index, 'TechPost2')"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-10" class="resume-card">
          <div slot="header" class="clearfix">
            <span>英语能力</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="语言等级">
                <el-input v-model="form.resume.FLv" maxlength="50" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="听说">
                <el-select v-model="form.resume.FListeningSpeakingID">
                  <el-option
                    v-for="(item, index) in options.FListeningSpeaking"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="读写">
                <el-select v-model="form.resume.FReadingWritingID">
                  <el-option
                    v-for="(item, index) in options.FReadingWriting"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-12" class="resume-card">
          <div slot="header" class="clearfix">
            <span>奖惩情况</span>
            <el-button type="danger" @click="addDynamicItem('rewardMember')"
              >新增</el-button
            >
          </div>
          <el-row
            v-for="(item, index) in form.rewardMember"
            :gutter="20"
            :key="index"
            class="dynamic-item"
          >
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="奖惩时间" required>
                    <el-date-picker
                      v-model="item.rewardDate"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="奖惩时间"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="奖惩部门" required>
                    <el-input v-model="item.rewardDept" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="奖惩情况" required>
                    <el-input v-model="item.rewardContent" maxlength="500" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="奖惩文件及编号" required>
                    <el-input v-model="item.rewardNo" maxlength="200" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-button @click="removeDynamicItem(index, 'rewardMember')"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-11" class="resume-card">
          <div slot="header" class="clearfix">
            <span>家庭成员及主要社会关系<span style="color: red">*</span></span>
            <p class="header-tip">父母、配偶、子女等填写详细完整</p>
            <el-button type="danger" @click="addDynamicItem('FamilyMember')"
              >新增</el-button
            >
          </div>
          <el-row
            v-for="(item, index) in form.FamilyMember"
            :gutter="20"
            :key="index"
            class="dynamic-item"
          >
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="与本人关系" required>
                    <el-select v-model="item.CFYbrgxjlID">
                      <el-option
                        v-for="(item, index) in options.CFYbrgxjl"
                        :key="index"
                        :value="item.fid"
                        :label="item.fname"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="姓名" required>
                    <el-input v-model="item.FName" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出生日期" required>
                    <el-date-picker
                      v-model="item.CFNl"
                      value-format="yyyy-MM"
                      type="date"
                      placeholder="出生日期"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="工作单位" required>
                    <el-input v-model="item.CFGzdw" maxlength="50" />
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item label="工作所在地" required>
                    <el-input v-model="item.FWorkDesc" maxlength="100" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-button @click="removeDynamicItem(index, 'FamilyMember')"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <el-card id="card-12" class="resume-card">
          <div slot="header" class="clearfix">
            <span>个人材料上传地址</span>
            <p class="header-tip">
              请在百度云中上传身份证、学历（学位）证书、职称证书、任职证明等扫描件，点击下载<a
                href="./static/doc/百度网盘上传附件说明的.docx"
                download="百度网盘上传附件说明的.docx"
                >《百度网盘上传附件说明》</a
              >。
            </p>
            <span>网盘地址填写示例</span>
            <p class="header-tip">地址：<u>https://pan.baidu.com/s/xxxxxxxxxxxxxxxxxxxxxxx</u>&nbsp;&nbsp;&nbsp;&nbsp;
              提取码：<u>xxxx</u></p>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="地址" prop="dz" :rules="[{required:isSocialRecruit, message:'请填写百度网盘共享链接', trigger:'blur'}
                , { validator:validateUrl, trigger: 'blur' }]">
                <el-input v-model="dz" maxlength="100" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提取码" prop="ma" :rules="{required:isSocialRecruit, message:'请填写提取码', trigger:'blur'}">
                <el-input v-model="ma" maxlength="6" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <div
          style="background-color: #fdf6ec; text-align: center; padding: 1rem 0"
        >
          <h5 style="color: #e6a23c">本人现做出以下承诺</h5>
          <p
            style="
              color: #e6a23c;
              font-size: 0.5rem;
              border-bottom: 1px solid #ddd;
              margin-bottom: 0.5rem;
              padding-bottom: 0.5rem;
            "
          >
            保证投递到贵公司的简历在个人证件、证书、工作经历真实无作伪且符合所应聘岗位要求，若有不相符之处，愿意承担相应责任。
          </p>
          <el-checkbox v-model="submitButtonDisable"
            >我已阅读并同意</el-checkbox
          >
          <el-button
            style="width: 30%; display: block; margin: 1rem auto"
            :disabled="!submitButtonDisable"
            type="danger"
            class="resume-submit"
            @click="submitResume"
            >提交简历</el-button
          >
        </div>
      </el-form>
    </section>
    <section class="menu-bar">
      <ul>
        <li @click="addClassFun(1)" :class="{ active: 1 == curMenuIndex }">
          <span v-show="1 != curMenuIndex"></span
          ><i class="el-icon-arrow-left" v-show="1 == curMenuIndex"></i>应聘信息
        </li>
        <li @click="addClassFun(2)" :class="{ active: 2 == curMenuIndex }">
          <span
            v-show="2 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="2 == curMenuIndex"></i>个人信息
        </li>
        <li @click="addClassFun(3)" :class="{ active: 3 == curMenuIndex }">
          <span
            v-show="3 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="3 == curMenuIndex"></i>求职意向
        </li>
        <li @click="addClassFun(4)" :class="{ active: 4 == curMenuIndex }">
          <span
            v-show="4 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="4 == curMenuIndex"></i>自我描述
        </li>
        <li @click="addClassFun(5)" :class="{ active: 5 == curMenuIndex }">
          <span
            v-show="5 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="5 == curMenuIndex"></i>工作经历
        </li>
        <li @click="addClassFun(6)" :class="{ active: 6 == curMenuIndex }">
          <span
            v-show="6 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="6 == curMenuIndex"></i>教育经历
        </li>
        <li @click="addClassFun(7)" :class="{ active: 7 == curMenuIndex }">
          <span
            v-show="7 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="7 == curMenuIndex"></i>项目经历
        </li>
        <li @click="addClassFun(8)" :class="{ active: 8 == curMenuIndex }">
          <span
            v-show="8 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="8 == curMenuIndex"></i>职称
        </li>
        <li @click="addClassFun(9)" :class="{ active: 9 == curMenuIndex }">
          <span
            v-show="9 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="9 == curMenuIndex"></i
          >职业资格及其他技能证书
        </li>
        <li @click="addClassFun(10)" :class="{ active: 10 == curMenuIndex }">
          <span
            v-show="10 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="10 == curMenuIndex"></i
          >英语能力
        </li>
        <li @click="addClassFun(11)" :class="{ active: 11 == curMenuIndex }">
          <span
            v-show="11 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="11 == curMenuIndex"></i
          >家庭成员及主要社会关系
        </li>
        <li @click="addClassFun(12)" :class="{ active: 12 == curMenuIndex }">
          <span
            v-show="12 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="12 == curMenuIndex"></i
          >个人材料上传地址
        </li>
        <!-- <li @click="addClassFun(13)" :class="{ active: 12 == curMenuIndex }">
          <span
            v-show="12 != curMenuIndex"
            style="width: 16px; display: inline-block"
          ></span
          ><i class="el-icon-arrow-left" v-show="12 == curMenuIndex"></i
          >个人材料上传地址
        </li> -->
      </ul>
    </section>
    <section style="clear: both"></section>
  </section>
</template>
<script>
import { regionData, CodeToText } from "element-china-area-data";
import { getRecruitDetail } from "api/recruit";
import { getOptions, getAvatarUrl, addResume } from "api/resume";
import IDValidator from "id-validator";
import { getMonthNum, objArrayKeySort } from "utils/index";
export default {
  data: () => {
    return {
      curMenuIndex: 1,
      cascaderOptions: regionData,
      auto: {
        FNowResidence: [],
        birthplace: [],
      },
      dz: null,
      ma: null,
      isSocialRecruit: true,
      isCertNoRequire: true,
      partytimeRequire: false,
      partytimeHidden: true,
      dialogVisible: false,
      endDatePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      avatarUrl: getAvatarUrl(),
      recruit: {
        zphd: null,
        department: null,
        id: null,
      },
      options: {
        FHDegree: [],
        FNational: [],
        Folk: [],
        FWed: [],
        FPoliticalFace: [],
        FCurrentWorkingStatus: [],
        CFQwyx: [],
        HYLB: [],
        GraduateType: [],
        AcademicDiplomas: [],
        TechPostLevel: [],
        FListeningSpeaking: [],
        FReadingWriting: [],
        CFYbrgxjl: [],
        XGZWLB: [],
        DriversLicenseDICT: [],
        JYLX: [],
      },
      submitButtonDisable: false,
      form: {
        name: "",
        myinfo: {},
        resume: {
          CFQwyxID: null,
          FCurrentWorkingStatusID: null,
          FSelfEvaluation: null,
          CFSftg: null,
          RECRUITID: null,
          AVATAR: null,
          Fname: null,
          Fsex: null,
          FIdentityCardNo: null,
          FPassportNo: null,
          Fbirthday: null,
          FHDegreeID: null,
          FWorkDate: null,
          FNowResidence: null,
          FMobilePhone: null,
          Femail: null,
          FNationalID: null,
          FolkID: null,
          FNativePlace: null,
          FDomicilePlace: null,
          FWedID: null,
          FPoliticalFaceID: null,
          partyTime: null,
          Fstature: null,
          FDriversLicense: null,
          FixedPhone: null,
          FQQ: null,
          FWeChat: null,
          FEmergencyContact: null,
          FEmergencyContactPhone: null,
          birthplace: null,
          appendixadd: null,
          otherspecial: null,
          workUnits: null,
        },
        WorkExp: [],
        EduExp: [],
        ProExp: [],
        TechPost: [],
        TechPost2: [],
        FamilyMember: [],
        rewardMember: [],
      },
      IDCardValidator: new IDValidator(),
    };
  },
  computed: {
    idCard() {
      return this.form.resume.FIdentityCardNo;
    }
  },
  watch: {
    idCard() {
      this._idcardHook();
    },
    dz() {
      this._updatedzma();
    },
    ma() {
      this._updatedzma();
    },
  },
  created() {
    this.id = this.$route.params.id;
    this._getRecruitDetail();
    this._getOptions();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, true);
  },
  methods: {
    //选择党员后填写入党时间
    chooseParty(index) {
      if (index == "5a5df0ce-0101-1000-e000-7b4ac0a83c7f791DBAAB") {
        this.partytimeRequire = true;
        this.partytimeHidden = false;
      } else {
        this.partytimeRequire = false;
        this.partytimeHidden = true;
      }
    },
    isCardID (rule, value, callback){
      let newvalue=this.form.resume.FIdentityCardNo
      if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(newvalue)) {
        callback(new Error('你输入的身份证长度或格式错误'))
      }
      //身份证城市
      var aCity = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
      if (!aCity[parseInt(newvalue.substr(0, 2))]) {
        callback(new Error('你的身份证地区非法'))
      }
 
      // 出生日期验证
      var sBirthday = (newvalue.substr(6, 4) + "-" + Number(newvalue.substr(10, 2)) + "-" + Number(newvalue.substr(12, 2))).replace(/-/g, "/"),
        d = new Date(sBirthday)
      if (sBirthday != (d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate())) {
        callback(new Error('身份证上的出生日期非法'))
      }
 
      // 身份证号码校验
      var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432"
      for (var i = 0; i < newvalue.length - 1; i++) {
        sum += newvalue[i] * weights[i];
      }
      var last = codes[sum % 11]; //计算出来的最后一位身份证号码
      if (newvalue[newvalue.length - 1] != last) {
        callback(new Error('你输入的身份证号非法'))
      }
 
      callback()
    },
    isCardIDCheck(value){
      let newvalue=value
      if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(newvalue)) {
        return false;
      }
      //身份证城市
      var aCity = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
      if (!aCity[parseInt(newvalue.substr(0, 2))]) {
        return false;
      }
 
      // 出生日期验证
      var sBirthday = (newvalue.substr(6, 4) + "-" + Number(newvalue.substr(10, 2)) + "-" + Number(newvalue.substr(12, 2))).replace(/-/g, "/"),
        d = new Date(sBirthday)
      if (sBirthday != (d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate())) {
        return false;
      }
 
      // 身份证号码校验
      var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432"
      for (var i = 0; i < newvalue.length - 1; i++) {
        sum += newvalue[i] * weights[i];
      }
      var last = codes[sum % 11]; //计算出来的最后一位身份证号码
      if (newvalue[newvalue.length - 1] != last) {
        return false;
      }
 
      return true;
    },
    validatePhone (rule, value, callback) {
      let reg = /^1[^2][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('手机号码格式不正确'));
      }
    },
    isValidPhone(value) {
      let reg = /^1[^2][0-9]\d{8}$/;
      return reg.test(value);
    },
    validateMail (rule, value, callback) {
      let reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('电子邮件地址格式不正确'));
      }
    },
    isValidMail(value) {
      let reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return reg.test(value);
    },
    validateUrl(rule, value, callback){
      if(this.dz === null || this.dz === ""){
        callback();
        return;
      }
      // 仅当输入了网盘链接时进行校验
      let reg = /^https:\/\/pan\.baidu\.com\/s\/[a-zA-Z0-9_-]+(\?pwd=[a-zA-Z0-9]{4,6})?$/;
      if (reg.test(this.dz)) {
        callback();
      } else {
        callback(new Error('网盘链接格式不正确'));
      }
    },
    isValidateUrl(value){
      let reg = /^https:\/\/pan\.baidu\.com\/s\/[a-zA-Z0-9_-]+(\?pwd=[a-zA-Z0-9]{4,6})?$/;
      return reg.test(value);
    },
    addClassFun(index) {
      this.curMenuIndex = index;
      document.getElementById("card-" + index).scrollIntoView(true);
    },
    onScroll(e) {
      const scrollItems = document.querySelectorAll(".resume-card");
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        const judge =
          scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop - 182;
        if (judge) {
          this.curMenuIndex = i;
          break;
        }
      }
    },
    handleFNowResidenceChange(value) {
      this.form.resume.FNowResidence = this.dzToStr(value);
    },
    handlebirthplaceChange(value) {
      this.form.resume.birthplace = this.dzToStr(value);
    },
    dzToStr(value) {
      var str = [];
      for (let i = 0; i < value.length; i++) {
        str[i] = CodeToText[value[i]];
      }
      return str.join("-");
    },
    _updatedzma() {
      if (this.dz === null || this.dz === "") {
        this.form.resume.appendixadd = null;
      } else if (this.ma === null || this.ma === "") {
        this.form.resume.appendixadd =
            "地址：" + this.dz;
      } else {
        this.form.resume.appendixadd =
            "地址：" + this.dz + "  提取码：" + this.ma;
      }
    },
    _idcardHook() {
      if (this.IDCardValidator.isValid(this.form.resume.FIdentityCardNo, 18)) {
        var result = this.IDCardValidator.getInfo(
          this.form.resume.FIdentityCardNo
        );
        if (result.sex === 0) {
          this.form.resume.Fsex = 2;
        } else {
          this.form.resume.Fsex = result.sex;
        }
        this.form.resume.Fbirthday = result.birth;
      }
    },
    _getOptions() {
      getOptions().then((data) => {
        if (data.code > 0) {
          this.options = data.data;
          for (let i = 0; i < this.options.FNational.length; i++) {
            if (this.options.FNational[i].fnumber === "01") {
              this.form.resume.FNationalID = this.options.FNational[i].fid;
            }
          }
        }
      });
    },
    addDynamicItem(data) {
      this.form[data].push({});
      if (data === "WorkExp") {
        for (let i = 0; i < this.form[data].length; i++) {
          this.$watch("form.WorkExp." + i + ".DateStart", () => {
            this.$set(
              this.form["WorkExp"][i],
              "XGGZNX",
              getMonthNum(
                this.form["WorkExp"][i]["DateStart"],
                this.form["WorkExp"][i]["DateEnd"]
              )
            );
          });
          this.$watch("form.WorkExp." + i + ".DateEnd", () => {
            this.$set(
              this.form["WorkExp"][i],
              "XGGZNX",
              getMonthNum(
                this.form["WorkExp"][i]["DateStart"],
                this.form["WorkExp"][i]["DateEnd"]
              )
            );
          });
        }
      }
    },
    removeDynamicItem(index, data) {
      this.form[data].splice(index, 1);
    },
    handleAvatarSuccess(res, file) {
      if (res.code > 0) {
        this.form.resume.AVATAR = res.data;
        this.form.Avatar = res.data;
      } else {
        this.$message({
          type: "error",
          message: res.msg,
        });
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    _getRecruitDetail() {
      getRecruitDetail(this.id).then((data) => {
        if (data.code > 0) {
          this.recruit = data.data[0];
          this.form.resume.RECRUITID = this.recruit.id;
          this.isSocialRecruit = this.recruit.zplx === '1';
        } else {
          this.$message({
            type: "error",
            message: data.msg,
          });
          // this.submitButtonDisable = true
        }
      });
    },
    changeCFSftg(value) {
      this.$message({
        type: "warning",
        message: "调岗可能意味着下调岗位",
      });
    },
    onChangeGraduateType(value) {
      this.isCertNoRequire = value === '76MAAAAAdP47UmXQ';
    },
    submitResume() {
      if (this.form.resume.Fname === null || this.form.resume.Fname === "") {
        this.$message({
          type: "error",
          message: "请填写姓名",
        });
      } else if (
        this.form.resume.CFSftg === null ||
        this.form.resume.CFSftg === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写是否同意调岗",
        });
      } 
      else if (
        this.form.resume.AVATAR === null ||
        this.form.resume.AVATAR === ""
      ) {
        this.$message({
          type: "error",
          message: "请上传照片",
        });
      }
       else if (
        this.form.resume.Fsex === null ||
        this.form.resume.Fsex === ""
      ) {
        this.$message({
          type: "error",
          message: "请选择性别",
        });
      } else if (
        this.form.resume.FIdentityCardNo === null ||
        this.form.resume.FIdentityCardNo === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写身份证号",
        });
      }else if (!this.isCardIDCheck(this.form.resume.FIdentityCardNo)) {
        this.$message({
          type: "error",
          message: "请正确填写身份证号",
        });
      } else if (
        this.form.resume.Fbirthday === null ||
        this.form.resume.Fbirthday === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写出生日期",
        });
      } else if (
        this.recruit.zplx === '1'
          && (this.form.resume.FWorkDate === null ||
              this.form.resume.FWorkDate === "")
      ) {
        this.$message({
          type: "error",
          message: "请填写参加工作时间",
        });
      } else if (
        this.form.resume.FHDegreeID === null ||
        this.form.resume.FHDegreeID === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写最高学历",
        });
      } else if (
        this.form.resume.FolkID === null ||
        this.form.resume.FolkID === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写民族",
        });
      } else if (
        this.form.resume.FNowResidence === null ||
        this.form.resume.FNowResidence === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写现居住地址",
        });
      } else if (
        this.form.resume.birthplace === null ||
        this.form.resume.birthplace === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写出生地",
        });
      } else if (
        this.form.resume.FDomicilePlace === null ||
        this.form.resume.FDomicilePlace === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写户口所在地",
        });
      } else if (
        this.form.resume.FNativePlace === null ||
        this.form.resume.FNativePlace === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写籍贯",
        });
      } else if (
        this.form.resume.FMobilePhone === null ||
        this.form.resume.FMobilePhone === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写手机号码",
        });
      } else if (!this.isValidPhone(this.form.resume.FMobilePhone)) {
        this.$message({
          type: "error",
          message: "请正确填写手机号码",
        });
      } else if (
        this.form.resume.Femail === null ||
        this.form.resume.Femail === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写电子邮箱",
        });
      } else if(!this.isValidMail(this.form.resume.Femail)) {
        this.$message({
          type: "error",
          message: "请正确填写电子邮箱",
        });
      } else if (
        this.form.resume.FPoliticalFaceID === null ||
        this.form.resume.FPoliticalFaceID === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写政治面貌",
        });
      } else if (
        this.form.resume.FWedID === null ||
        this.form.resume.FWedID === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写婚姻状态",
        });
      } else if (
        this.form.resume.FEmergencyContact === null ||
        this.form.resume.FEmergencyContact === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写紧急联系人",
        });
      } else if (
        this.form.resume.FEmergencyContactPhone === null ||
        this.form.resume.FEmergencyContactPhone === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写紧急联系人电话",
        });
      } else if (
        this.recruit.zplx === '1'
          && (this.form.resume.CFQwyxID === null ||
              this.form.resume.CFQwyxID === "")
      ) {
        this.$message({
          type: "error",
          message: "请填写期望月薪",
        });
      } else if (
        this.recruit.zplx === '1'
          && (this.form.resume.FCurrentWorkingStatusID === null ||
              this.form.resume.FCurrentWorkingStatusID === "")
      ) {
        this.$message({
          type: "error",
          message: "请填写目前工作状态",
        });
      } else if (
        this.form.resume.FSelfEvaluation === null ||
        this.form.resume.FSelfEvaluation === ""
      ) {
        this.$message({
          type: "error",
          message: "请填写自我描述",
        });
      } else if (this.recruit.zplx === '1' && (this.dz === null || this.dz === "")) {
        this.$message({
          type: "error",
          message: "请填写百度网盘地址",
        });
      } else if(this.dz !== null && this.dz !== "" && !this.isValidateUrl(this.dz)) {
        this.$message({
          type: "error",
          message: "不是有效的百度网盘链接",
        });
      } else if (this.recruit.zplx === '1' && (this.ma === null || this.ma === "")) {
        this.$message({
          type: "error",
          message: "请填写百度网盘提取码",
        });
      } else {
        this.form.EduExp = objArrayKeySort(this.form.EduExp);
        this.form.FamilyMember = objArrayKeySort(this.form.FamilyMember);
        if (
          this.form.EduExp.length === 0 ||
          this.form.FamilyMember.length === 0
        ) {
          this.$message({
            type: "error",
            message: "请填写至少一个教育经历和家庭成员及主要社会关系。",
          });
        } else {
          var count = 0;
          var msg = "";

          this.form.WorkExp = objArrayKeySort(this.form.WorkExp);
          this.form.WorkExp.forEach(function (e) {
            if (
              typeof e.DateStart === "undefined" ||
              e.DateStart === null ||
              e.DateStart === ""
            ) {
              count++;
            }
            if (
              typeof e.DateEnd === "undefined" ||
              e.DateEnd === null ||
              e.DateEnd === ""
            ) {
              count++;
            }
            if (
              typeof e.XGGZNX === "undefined" ||
              e.XGGZNX === null ||
              e.XGGZNX === ""
            ) {
              count++;
            }
            if (
              typeof e.Company === "undefined" ||
              e.Company === null ||
              e.Company === ""
            ) {
              count++;
            }
            if (
              typeof e.TotalStaff === "undefined" ||
              e.TotalStaff === null ||
              e.TotalStaff === ""
            ) {
              count++;
            }
            if (
              typeof e.Department === "undefined" ||
              e.Department === null ||
              e.Department === ""
            ) {
              count++;
            }
            if (
              typeof e.HYLBID === "undefined" ||
              e.HYLBID === null ||
              e.HYLBID === ""
            ) {
              count++;
            }
            if (
              typeof e.XGZWLBID === "undefined" ||
              e.XGZWLBID === null ||
              e.XGZWLBID === ""
            ) {
              count++;
            }
            if (
              typeof e.Position === "undefined" ||
              e.Position === null ||
              e.Position === ""
            ) {
              count++;
            }
            if (
              typeof e.MonthPay === "undefined" ||
              e.MonthPay === null ||
              e.MonthPay === ""
            ) {
              count++;
            }
            if (
              typeof e.Certifier === "undefined" ||
              e.Certifier === null ||
              e.Certifier === ""
            ) {
              count++;
            }
            if (
              typeof e.CertifierPhone === "undefined" ||
              e.CertifierPhone === null ||
              e.CertifierPhone === ""
            ) {
              count++;
            }
            if (
              typeof e.JobDescription === "undefined" ||
              e.JobDescription === null ||
              e.JobDescription === ""
            ) {
              count++;
            }
          });
          if (count > 0) {
            msg += "请补充完整工作经历必填项。";
          }
          count = 0;
          this.form.EduExp.forEach(function (e) {
            if (
              typeof e.School === "undefined" ||
              e.School === null ||
              e.School === ""
            ) {
              count++;
            }
            if (
              typeof e.Major === "undefined" ||
              e.Major === null ||
              e.Major === ""
            ) {
              count++;
            }
            if (
              typeof e.JYLXID === "undefined" ||
              e.JYLXID === null ||
              e.JYLXID === ""
            ) {
              count++;
            }
            if (
              typeof e.DateStart === "undefined" ||
              e.DateStart === null ||
              e.DateStart === ""
            ) {
              count++;
            }
            if (
              typeof e.DateEnd === "undefined" ||
              e.DateEnd === null ||
              e.DateEnd === ""
            ) {
              count++;
            }
            if (
              typeof e.GraduateTypeID === "undefined" ||
              e.GraduateTypeID === null ||
              e.GraduateTypeID === ""
            ) {
              count++;
            }
            if (
              typeof e.DegreeID === "undefined" ||
              e.DegreeID === null ||
              e.DegreeID === ""
            ) {
              count++;
            }
            if (
              typeof e.XLZS_NO === "undefined" ||
              e.XLZS_NO === null ||
              e.XLZS_NO === ""
            ) {
              if(e.GraduateTypeID === '76MAAAAAdP47UmXQ')
                count++;
            }
            if (
              typeof e.AcademicDiplomasID === "undefined" ||
              e.AcademicDiplomasID === null ||
              e.AcademicDiplomasID === ""
            ) {
              count++;
            }
            if (
              typeof e.MajorDescription === "undefined" ||
              e.MajorDescription === null ||
              e.MajorDescription === ""
            ) {
              count++;
            }
          });
          if (count > 0) {
            msg += "请补充完整教育经历必填项。";
          }
          count = 0;

          this.form.ProExp = objArrayKeySort(this.form.ProExp);
          this.form.ProExp.forEach(function (e) {
            if (
              typeof e.DateStart === "undefined" ||
              e.DateStart === null ||
              e.DateStart === ""
            ) {
              count++;
            }
            if (
              typeof e.DateEnd === "undefined" ||
              e.DateEnd === null ||
              e.DateEnd === ""
            ) {
              count++;
            }
            if (
              typeof e.Customer === "undefined" ||
              e.Customer === null ||
              e.Customer === ""
            ) {
              count++;
            }
            if (
              typeof e.Findustry === "undefined" ||
              e.Findustry === null ||
              e.Findustry === ""
            ) {
              count++;
            }
            if (
              typeof e.Frole === "undefined" ||
              e.Frole === null ||
              e.Frole === ""
            ) {
              count++;
            }
            if (
              typeof e.Fduty === "undefined" ||
              e.Fduty === null ||
              e.Fduty === ""
            ) {
              count++;
            }
            if (
              typeof e.ProjectDescription === "undefined" ||
              e.ProjectDescription === null ||
              e.ProjectDescription === ""
            ) {
              count++;
            }
          });
          if (count > 0) {
            msg += "请补充完整项目经历必填项。";
          }
          count = 0;

          this.form.TechPost = objArrayKeySort(this.form.TechPost);
          this.form.TechPost.forEach(function (e) {
            if (
              typeof e.CredentialName === "undefined" ||
              e.CredentialName === null ||
              e.CredentialName === ""
            ) {
              count++;
            }
            if (
              typeof e.LevelID === "undefined" ||
              e.LevelID === null ||
              e.LevelID === ""
            ) {
              count++;
            }
            if (
              typeof e.Grade === "undefined" ||
              e.Grade === null ||
              e.Grade === ""
            ) {
              count++;
            }
            if (
              typeof e.Date === "undefined" ||
              e.Date === null ||
              e.Date === ""
            ) {
              e.Date = null;
            }
            if (
              typeof e.TCB === "undefined" ||
              e.TCB === null ||
              e.TCB === ""
            ) {
              count++;
            }
          });
          if (count > 0) {
            msg += "请补充完整职称必填项。";
          }
          count = 0;

          this.form.TechPost2 = objArrayKeySort(this.form.TechPost2);
          this.form.TechPost2.forEach(function (e) {
            if (
              typeof e.CredentialName === "undefined" ||
              e.CredentialName === null ||
              e.CredentialName === ""
            ) {
              count++;
            }
            if (
              typeof e.LevelID === "undefined" ||
              e.LevelID === null ||
              e.LevelID === ""
            ) {
              count++;
            }
            if (
              typeof e.Grade === "undefined" ||
              e.Grade === null ||
              e.Grade === ""
            ) {
              count++;
            }
            if (typeof e.Date === "undefined") {
              e.Date = null;
            }
            if (
              typeof e.TCB === "undefined" ||
              e.TCB === null ||
              e.TCB === ""
            ) {
              count++;
            }
          });
          if (count > 0) {
            msg += "请补充完整职（执）业资格及其他技能证书必填项。";
          }
          count = 0;

          this.form.FamilyMember.forEach(function (e) {
            if (
              typeof e.CFYbrgxjlID === "undefined" ||
              e.CFYbrgxjlID === null ||
              e.CFYbrgxjl === ""
            ) {
              count++;
            }
            if (
              typeof e.FName === "undefined" ||
              e.FName === null ||
              e.FName === ""
            ) {
              count++;
            }
            if (
              typeof e.CFNl === "undefined" ||
              e.CFNl === null ||
              e.CFNl === ""
            ) {
              count++;
            }
            if (
              typeof e.CFGzdw === "undefined" ||
              e.CFGzdw === null ||
              e.CFGzdw === ""
            ) {
              count++;
            }
            if (
              typeof e.FWorkDesc === "undefined" ||
              e.FWorkDesc === null ||
              e.FWorkDesc === ""
            ) {
              count++;
            }
          });
          if (count > 0) {
            msg += "请补充完整家庭成员必填项。";
          }
          count = 0;
          this.form.rewardMember = objArrayKeySort(this.form.rewardMember);
          this.form.rewardMember.forEach(function (e) {
            if (
              typeof e.rewardDate === "undefined" ||
              e.rewardDate === null ||
              e.rewardDate === ""
            ) {
              count++;
            }
            if (
              typeof e.rewardDept === "undefined" ||
              e.rewardDept === null ||
              e.rewardDept === ""
            ) {
              count++;
            }
            if (
              typeof e.rewardContent === "undefined" ||
              e.rewardContent === null ||
              e.rewardContent === ""
            ) {
              count++;
            }
            if (
              typeof e.rewardNo === "undefined" ||
              e.rewardNo === null ||
              e.rewardNo === ""
            ) {
              count++;
            }
          });
          if (count > 0) {
            msg += "请补充完整奖惩情况。";
          }
          count = 0;
          if (msg !== "") {
            this.$message({
              type: "error",
              message: msg,
            });
          } else {
            this.$confirm(
              "请确认填写无误，确认提交后将无法对简历信息进行修改。",
              "提示",
              {
                confirmButtonText: "确认提交",
                type: "warning",
              }
            ).then(() => {
              addResume(this.form).then((data) => {
                if (data.code === 1) {
                  //this.$message({
                  //  type: 'success',
                  //  message: data.msg
                  //})
                  this.$router.push({
                    path: "/resume/success/",
                  });
                } else if (data.code === 0) {
                  this.$router.push({
                    path:
                      "/resume/error/" +
                      "感谢您对徐州地铁的关注,您不符合该岗位的投递条件,谢谢。",
                  });
                } else if (data.code === 2) {
                  this.$message({
                    type: "error",
                    message: data.msg,
                  });
                }
              });
            });
          }
        }
      }
    },
  },
};
</script>
<style>
.pathInfo {
  font-size: 12px;
  border-bottom: #eeeeee solid 1px;
  height: 1.8rem;
  width: 75%;
  margin: 1rem 2rem 0 2rem;
}
.oneMain {
  display: flex;
  justify-content: space-between;
}
.oneMain > div {
  width: 30%;
}
.el-cascader-node {
  color: #606266;
}
.el-input__count {
  position: absolute;
  /* top: -10px; */
  bottom: -5px;
  right: 10px;
  color: #606266;
}
.el-card__header {
  font-weight: bold;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/resume/index.vue